export const environment = {
  production: false,
  hmr: false,
  version: require('../../package.json').version,
  coursesApiUrl: 'https://ci-crud.spaces.wondavr.com',
  coursesSocketUrl: 'wss://ci-crud.spaces.wondavr.com/websocket',
  assetManagerUrl: 'https://ci-assets-manager.spaces.wondavr.com',
  contentBucketPrefix: 'https://ci-content.spaces.wondavr.com',
  assetsBucketPrefix: 'https://ci-assets.spaces.wondavr.com',
  analyticsServiceUrl: 'https://ci-analytics.spaces.wondavr.com',
  generateSubtitleTrigger: 'https://europe-west1-ci-spaces.cloudfunctions.net/ci-spaces-generateTranscriptionSubtitle',
  templateFile: 'https://ci-assets.spaces.wondavr.com/templates/templates.json',
  simulationsTemplateFile: 'https://ci-assets.spaces.wondavr.com/templates/simulations_templates.json',
  programsTemplateFile: 'https://ci-assets.spaces.wondavr.com/templates/programs_templates.json',
  voiceSelectionFile: `https://ci-assets.spaces.wondavr.com/voice-config/tts-voices-config.json`,
  languagePresetFile: `https://ci-assets.spaces.wondavr.com/languages/language-preset.json`,
  latestUseCaseFile:`https://eu-assets.spaces.wondavr.com/use-cases/latest-use-cases.json`,
  fromTheCommunityListFile:`https://ci-assets.spaces.wondavr.com/from-the-community/from-the-community.json`, // TODO: Generate CI file on the model of templates
  cookieSubdomain: '.wondavr.com',
  proUrl: 'https://ci-pro.wondavr.com',
  labsUrl: 'https://ci-spaces.wondavr.com',
  firebase: {
    apiKey: 'AIzaSyAygCjpshp_EumLlidgv5T6phkd0ioxgiw ',
    authDomain: 'ci-spaces.firebaseapp.com',
    databaseURL: 'https://ci-spaces.firebaseio.com',
    projectId: 'ci-spaces',
    storageBucket: 'ci-spaces.appspot.com',
    messagingSenderId: '292133743902'
  },
  quizDefaultImageId: '772e88d0-e103-11e8-b9a1-2d3ebd9be4e9',
  intercom_app_id: 'z0vfygyg',
  heap_id: '3779749161',
  googleTagManager: 'GTM-TZFG6W6K',
  welcomeMessageUrl: 'https://wondavr.com/welcome/welcome.html',
  imlabHubId: 'e6f02ee0-7883-11e9-b100-e5591d5740a0',
  googleAnalyticsFlowId: 'G-531PGCPKKC',
  stripePublishableKey: 'pk_test_51RurBlBZB70Grc3Vglakym5ePaLpHEcZdQ3IWCKTj8MrjORhoqAz0u34OlSLOVj8N1TsonJHp1dn2fP06GHBqIBK00rXV8mZEa'
};
